export default __webpack_public_path__ + "static/media/dalenhotel_thumb.95176c21.jpg";